import React from "react";

import { Slider as SliderComponent } from "~/sdks/LocalContent/components/Slider";

import { useRootElement } from "../context";

import * as styles from "./styles";

export function Slider({ children }: { children?: React.ReactNode }) {
  const { activeScore, isExpanded } = useRootElement();

  return (
    <SliderComponent
      isOpen={isExpanded && !!activeScore}
      className={styles.container}
    >
      {children}
    </SliderComponent>
  );
}
